import styled, {css} from 'styled-components';
import defaultAvatar from '../../../assets/images/icons/user-avater.png';
import {useTranslation} from 'react-i18next';
import { Link } from 'react-router-dom';
import {List} from 'antd';
import BG from '../../../assets/images/report-list-bg.png';

const Item = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 19px;

  .label {
    font-size: 12px;
    font-weight: 400;
    color: #4B555E;
  }
`

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 17px;
  border: 2px solid transparent;
  ${({rank}) => {
      if (rank === 1) return css`border-color: #F3E078;`
      else if (rank === 2) return css`border-color: #E9EBFB;`
      else if (rank === 3) return css`border-color: #ECC690;`
      else return css`border-color: transparent`
  }}
`

const Info = styled.div`
  flex: 1;
  .name {
    font-size: 13px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
    max-width: 30vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

const Rewards = styled.div`
    text-align: right;
  margin-right: 12px;
  .rewards {
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
`

const AuthorItem = ({item, rank}) => {
    const { t } = useTranslation();

    return (
        <List.Item>
            <Item to={`/whiteHats/${item.user.name}`}>
                <Avatar rank={rank} src={item.user.avatar || defaultAvatar} />
                <Info>
                    <div className='name'>{item.user.name}</div>
                    <div className='label'>Report Count: {item.user.reports_count || 0}</div>
                </Info>
                <Rewards>
                    <div className='rewards'>{item.rewards.toLocaleString(navigator.language)}</div>
                    <div className='label'>{t('AuthorTable.rewards')}  (USDC)</div>
                </Rewards>
                <img width={8} src={require('../../../assets/images/icons/arrow-right.png')} alt=""/>
            </Item>
        </List.Item>
    )
}

export const AuthorList = ({data, loading, pagination = {}}) => {
    const {current = 0, pageSize = 10} = pagination
    return (
        <List
            loading={loading}
            dataSource={data}
            pagination={pagination}
            renderItem={(item, i) => (
                <AuthorItem item={item} rank={(current - 1) * pageSize + i + 1} />
            )}/>
    )
}